import { Pressable, View } from "react-native"
import { H5, Small } from "@/components/standard/BFText"
import { type SvgProps } from "react-native-svg"
import { cn } from "@/components/util/cn"
import Karet from "phosphor-react-native/src/icons/CaretRight"
import { Vertical } from "@/components/standard/BFLayout"
import { numberToCurrency, stringToNumber } from "@/utils/NumberUtils"
import { type ContingencyType } from "@/types/rehabTypes"

interface CategoryButtonProps {
  label: string
  sublabel?: string
  icon: React.FC<SvgProps> // Required
  onPress: () => void
  selected?: boolean
  amount?: string | number
  contingencyType?: ContingencyType // Optional, only for contingency
  disabled?: boolean
}

export default function CategoryButton({
  label,
  sublabel,
  icon: Icon,
  onPress,
  selected = false,
  amount = "$0",
  contingencyType,
  disabled = false,
}: CategoryButtonProps) {
  const isContingency = contingencyType !== undefined

  return (
    <Pressable
      testID={`category-button-${label}`}
      onPress={onPress}
      disabled={disabled}
    >
      <View
        className={cn(
          "flex flex-row items-center justify-between self-center",
          "w-full h-[80px] p-[14px] border rounded-[6px]",
          selected ? "border-calm-blue" : "border-light-grey"
        )}
      >
        <View
          style={{ opacity: disabled ? 0.5 : 1 }}
          className="flex flex-row items-center gap-[7px]"
        >
          <Icon width={24} height={24} />
          <Vertical>
            <H5 className="ml-1 text-midnight-blue font-bold">{label}</H5>
            {sublabel && (
              <Small
                numberOfLines={2}
                className="text-dark-grey ml-1 max-w-[190px]"
              >
                {sublabel}
              </Small>
            )}
          </Vertical>
        </View>

        <View
          style={{ opacity: disabled ? 0.5 : 1 }}
          className="flex flex-row items-center"
        >
          <H5 className="text-midnight-blue mr-2">
            {isContingency
              ? numberToCurrency(
                  Math.round(stringToNumber(contingencyType.value))
                )
              : amount}
          </H5>
          <Karet />
        </View>
      </View>
    </Pressable>
  )
}
